export const COMPARTMENTATION_ENUM = {
    PER_TOTAL: 0,
    PER_FLOOR: 1,
    PER_APARTMENT: 2,
  };
  
  export const COMPARTMENTATION_OPTIONS = [
    { label: 'Întreagă locație', value: COMPARTMENTATION_ENUM.PER_TOTAL },
    { label: 'Fiecare etaj separat', value: COMPARTMENTATION_ENUM.PER_FLOOR },
    { label: 'Fiecare apartament separat', value: COMPARTMENTATION_ENUM.PER_APARTMENT },
  ];